import { Alert, Button, DialogRef, QueryState, Stack, Typography } from 'src/app/components'
import { useRef } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { usePermissions } from 'src/app/hooks/permissions-hook'
import { useSalesPromoDetailTabDetail } from './SalesPromoDetailTabDetail.hook'
import SalesPromoDetailTabGeneralInfo from './SalesPromoDetailTabGeneral'
import { SalesPromoModel } from '../../../models/SalesPromo.model'


function SalesPromoDetailTabDetail() {
  const state = useSalesPromoDetailTabDetail()
  const data: SalesPromoModel = state.generalInfo.data
  const alertDeleteRef = useRef<DialogRef>(null);
  const { id, path } = useParams<{ id: string, path: string }>();
  const history = useHistory();
  const permission = usePermissions();

  const handleDelete = () => {
    state.deleteSalesPromo.mutate(id, {
      onSuccess: () => {
        // ✅ Close the page (navigate away) on success
        history.replace("/campaign/list/sales-promo");
      },
    });
  };

  return (
    <>
      <QueryState query={state.generalInfo}>
        <div>
          <SalesPromoDetailTabGeneralInfo data={data} />
          {path === 'detail' && data?.status !== 'INACTIVE' && (
            <Stack className="border-t pt-4 mt-4 border-neutral-200 pb-1 pr-[0.25rem]" direction="row" gap={4}>
              <Stack direction="row" justify="end" gap={4}>
                {permission.setVisibleByAccess(
                  ['manage_campaign_sales_promo.delete'], data?.status !== 'ACTIVE' && (
                    <Button variant="outlined" color="danger" onClick={() => alertDeleteRef.current?.show()}>
                      Delete Sales Promotion
                    </Button>
                  ))}
                {permission.setVisibleByAccess(
                  ['manage_campaign_sales_promo.update'],
                  <Button className='px-8' to={`/campaign/sales-promo/form/${id}`}>Edit</Button>
                )}
              </Stack>
            </Stack>
          )}
        </div>
      </QueryState>
      <Alert
        cancelText="Cancel"
        submitText="Delete"
        onSubmit={handleDelete}
        title="Delete Sales Promotion?"
        ref={alertDeleteRef}
        closeOnBackdropClicked={false}
      >
        <Typography>
          Are you sure you want to delete this sales promotion? This action cannot be undone, and all related data will be lost.
        </Typography>
      </Alert>
    </>
  )
}

export default SalesPromoDetailTabDetail
